import { motion } from "framer-motion";

const CONTENT = {
  impressum: {
    title: "Impressum",
    sections: [
      {
        heading: "Angaben gemäß § 5 TMG",
        text: "Auralia\nEnergetische Heilpraxis\n[Platzhalter: Straße, Hausnummer]\n[Platzhalter: PLZ, Stadt]\nDeutschland",
      },
      {
        heading: "Kontakt",
        text: "E-Mail: info@auralia.de\nTelefon: [Platzhalter: +49 ...]",
      },
      {
        heading: "Haftungsausschluss",
        text: "Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.",
      },
    ],
  },
  datenschutz: {
    title: "Datenschutzerklärung",
    sections: [
      {
        heading: "1. Datenschutz auf einen Blick",
        text: "Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung von personenbezogenen Daten innerhalb unseres Onlineangebotes auf.",
      },
      {
        heading: "2. Verantwortliche Stelle",
        text: "Auralia – Energetische Heilpraxis\n[Platzhalter: vollständige Adresse]\n\nBei Fragen wenden Sie sich bitte an: info@auralia.de",
      },
      {
        heading: "3. Erhobene Daten",
        text: "Im Rahmen von Buchungen und Kontaktanfragen erheben wir: Name, E-Mail-Adresse, Telefonnummer, Wunschtermin sowie optionale Nachrichten. Diese Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage genutzt und nicht an Dritte weitergegeben.",
      },
      {
        heading: "4. Ihre Rechte",
        text: "Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Zur Ausübung dieser Rechte wenden Sie sich an: info@auralia.de",
      },
    ],
  },
  agb: {
    title: "Allgemeine Geschäftsbedingungen",
    sections: [
      {
        heading: "§ 1 Geltungsbereich",
        text: "Diese Allgemeinen Geschäftsbedingungen gelten für alle Buchungen und Dienstleistungen der Auralia Energetischen Heilpraxis.",
      },
      {
        heading: "§ 2 Leistungen",
        text: "Alle Sitzungen finden als Remote-Sessions statt. Eine Buchungsbestätigung erfolgt per E-Mail nach Prüfung der Verfügbarkeit.",
      },
      {
        heading: "§ 3 Stornierung",
        text: "Eine kostenlose Stornierung ist bis 48 Stunden vor dem gebuchten Termin möglich. Bei späteren Absagen oder Nichterscheinen wird der volle Betrag berechnet.",
      },
      {
        heading: "§ 4 Haftungsausschluss",
        text: "Die angebotenen energetischen Leistungen ersetzen keine medizinische Behandlung und stellen keine Heilversprechen dar. Auralia übernimmt keine Haftung für die Ergebnisse der Sitzungen.",
      },
    ],
  },
};

export default function LegalPage({ type }) {
  const content = CONTENT[type] || CONTENT.impressum;

  return (
    <div className="bg-[#050510] text-[#F0EDE8] min-h-screen pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-[0.65rem] uppercase tracking-[0.4em] text-[#C9A84C] mb-4">
            Rechtliches
          </p>
          <h1
            className="text-5xl font-light text-[#F0EDE8] mb-12"
            style={{ fontFamily: "Cormorant Garamond, serif" }}
          >
            {content.title}
          </h1>

          <div className="space-y-10">
            {content.sections.map(({ heading, text }) => (
              <div key={heading}>
                <h2
                  className="text-xl font-light text-[#F0EDE8] mb-4"
                  style={{ fontFamily: "Cormorant Garamond, serif" }}
                >
                  {heading}
                </h2>
                <p className="text-[#9A9A9A] text-sm leading-relaxed whitespace-pre-line">
                  {text}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
